import { lazy, Suspense } from 'react';
import Navbar from '@/components/Navbar';
import Hero from '@/components/Hero';
import ProofOfWork from '@/components/ProofOfWork';
import About from '@/components/About';
import Services from '@/components/Services';
import Tools from '@/components/Tools';
import Portfolio from '@/components/Portfolio';
import Journey from '@/components/Journey';
import Notes from '@/components/Notes';
import Faq from '@/components/Faq';
import Contact from '@/components/Contact';
import Footer from '@/components/Footer';
import BackToTop from '@/components/BackToTop';
import { useSmoothScroll } from '@/hooks/useSmoothScroll';
 
const Chatbot = lazy(() => import('@/components/Chatbot'));
 
const Index = () => {
  useSmoothScroll();

  return (
    <div className="min-h-screen bg-background text-foreground overflow-x-hidden">
      <Navbar />
      <main>
        <Hero />
        <ProofOfWork />
        <About />
        <Services />
        <Tools />
        <Portfolio />
        <Journey />
        <Notes />
        <Faq />
        <Contact />
      </main>
      <Footer />
      <BackToTop />
      <Suspense fallback={null}>
        <Chatbot />
      </Suspense>
    </div>
  );
};
 
export default Index;
